// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import {
  type DistanceDurationPair,
  type DistanceDurationPairWireFormat,
  NewDistanceDurationPair,
} from '../DistanceDurationPair/DistanceDurationPair';

export class DistanceResultsByOrigin {
  readonly origin: string;
  readonly resultsForOrigin: DistanceDurationPair[];

  constructor(data: { [key: string]: any } = {}) {
    this.origin = data.origin === undefined ? '' : data.origin;
    this.resultsForOrigin = (data.resultsForOrigin ?? []).map((resultsForOrigin: any) =>
      NewDistanceDurationPair(resultsForOrigin),
    );
  }

  static zero(): DistanceResultsByOrigin {
    const zeroValues: ExcludeMethodsDeep<DistanceResultsByOrigin> = {
      origin: '',
      resultsForOrigin: [],
    };
    return new DistanceResultsByOrigin(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************

  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type DistanceResultsByOriginWireFormat = {
  origin: string;
  resultsForOrigin: DistanceDurationPairWireFormat[];
};

type NewDistanceResultsByOriginProps = PartialDeep<
  DistanceResultsByOrigin,
  { recurseIntoArrays: true }
>;
export const NewDistanceResultsByOrigin: (
  props: NewDistanceResultsByOriginProps,
) => DistanceResultsByOrigin = (props) => new DistanceResultsByOrigin(props);

type NewDistanceResultsByOriginFromWireFormatProps = PartialDeep<
  DistanceResultsByOriginWireFormat,
  { recurseIntoArrays: true }
>;
export const NewDistanceResultsByOriginFromWireFormat: (
  props: NewDistanceResultsByOriginFromWireFormatProps,
) => DistanceResultsByOrigin = (props) => new DistanceResultsByOrigin(props);
